<template>
  <!-- Layout: -->
  <basic-portlet title="VjsModal Demos">
    <b-row>
      <b-col>
        <div class="demo-block">
          <h3>Basic modals:</h3>
          <hr>
          <ul class="clean-list">
            <li>
              <b-button variant="ss" @click="() => showModal(modal_types.base)">
                Base (templated)
              </b-button>
            </li>
            <li>
              <b-button variant="ss" @click="() => showModal(modal_types.confirm)">
                Confirm
              </b-button>
            </li>
            <li>
              <b-button variant="ss" @click="() => showModal(modal_types.alert)">
                Alert
              </b-button>
            </li>
            <li>
              <b-button variant="ss" :disabled="loading" @click="() => showModal(modal_types.social)">
                Social share
              </b-button>
            </li>
            <li>
              <b-button variant="ss" :disabled="loading" @click="() => showModal(modal_types.entity_select)">
                Entity selection
              </b-button>
            </li>
            <li>
              <b-button variant="ss" @click="() => showModal(modal_types.delete_confirm)">
                Delete Confirm
              </b-button>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col>
        <div class="demo-block">
          <h3>More complex modals:</h3>
          <hr>
          <ul class="clean-list">
            <li>
              <b-button variant="ss" @click="() => showModal(modal_types.sync_feed_item_tags)">
                Sync Items -> Feeds via tags
              </b-button>
            </li>
            <li>
              <b-button variant="ss" @click="() => showModal(modal_types.sync_feed_tags_items)">
                Sync Tags -> Items for feed
              </b-button>
            </li>
            <li>
              <b-button variant="ss" @click="() => showModal(modal_types.password_confirm)">
                Password confirm
              </b-button>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="demo-block">
          <h3>Misc. & admin:</h3>
          <ul class="clean-list">
            <li>
              <b-button variant="ss"
                        @click="() => showModal(modal_types.quick_alert, {
                          title: `Quick alert!`,
                          message: `This modal is fired via a method call, like Swal!`,
                          variant: `info`,
                        })">
                Quick alert (swal-like)
              </b-button>
            </li>
            <li>
              <b-button variant="ss"
                        @click="() => showModal(modal_types.quick_alert, {
                          title: `Another quick alert!`,
                          message: `All controlled by the call site!`,
                          variant: `error`,
                          showCancel: true,
                        })">
                Quick alert (swal-like) w/ cancel
              </b-button>
            </li>
            <li>
              <b-button variant="ss" @click="() => showModal(modal_types.add_user)">
                Add user
              </b-button>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>

    <!-- Modals: -->
    <!-- Base, template-based modal: -->
    <vjs-modal :name="modal_types.base" title="Base (templated)">
      <template slot="header-controls">
        <b-button variant="ss" @click="() => exampleBtnClick()">
          Example
        </b-button>
      </template>
      <template slot="body-content">
        <b-row>
          <b-col>
            <h3>Some kind of content:</h3>
            <p>
              Id illum eos dolore aut. Voluptatem omnis eos minima.
              Tempora eos libero sunt atque architecto qui dolores dicta.
              Sed est consequuntur numquam voluptatem facere aut quia inventore.
            </p>
          </b-col>
          <b-col>
            <img alt="Logo" style="height: 60px;" src="/build/media/logo/logo_timbre.png">
            <hr>
            <p>Cool!</p>
          </b-col>
        </b-row>
      </template>
      <template slot="body-controls">
        <b-button variant="ss" @click="() => hideModal(modal_types.base)">
          Close
        </b-button>
      </template>
    </vjs-modal>

    <!-- Pre-baked modals: -->
    <!-- Alert/nofif modal: -->
    <alert-modal :name="modal_types.alert" title="Alert example!" message="Some kind of alert of notification!" />
    <!-- Confirmation modal: -->
    <confirm-modal :name="modal_types.confirm" title="Confirmation example">
      <div>hi</div>
    </confirm-modal>
    <!-- Delete confirm: -->
    <delete-confirm-modal :name="modal_types.delete_confirm" :entities-to-delete="feeds.slice(0, 2)" entity-type="Feed" />
    <!-- Entity select: -->
    <entity-selection-modal v-if="!loading"
                            :name="modal_types.entity_select"
                            :entities="[...feeds, ...feeds]"
                            entity-type="Feed"
                            ms-track-by="uuid"
                            ms-label="name" />
    <!-- Social: -->
    <social-share-modal v-if="!loading"
                        :name="modal_types.social"
                        :entity="feeds[0]"
                        :draggable="true" />
    <!-- Sync feeds -> items via tags -->
    <sync-items-to-feed-by-tag-modal :name="modal_types.sync_feed_item_tags" :feeds="feeds.slice(0, 2)" />
    <!-- Sync tags -> items for feeds -->
    <sync-feed-tags-to-items-modal :name="modal_types.sync_feed_tags_items" :feeds="feeds.slice(0, 2)" />
    <!-- Pwd confirmation -->
    <password-confirm-modal :name="modal_types.password_confirm" />
    <!-- swal-like quick alert -->
    <quick-alert-modal v-bind="quick_alert" />
    <!-- Add user -->
    <add-user-modal :modal-name="modal_types.add_user" :customer="customer" />
  </basic-portlet>
</template>

<script>
// layout
import BasicPortlet from 'VueComponents/BasicPortlet';
// modals
import VjsModal from 'VueModals/VjsModal';
import AlertModal from 'VueModals/AlertModal';
import ConfirmModal from 'VueModals/ConfirmModal';
import DeleteConfirmModal from 'VueModals/DeleteConfirmModal';
import EntitySelectionModal from 'VueModals/EntitySelectionModal';
import SocialShareModal from 'VueModals/SocialShareModal';
import SyncItemsToFeedByTagModal from 'VueModals/SyncItemsToFeedByTagModal';
import SyncFeedTagsToItemsModal from 'VueModals/SyncFeedTagsToItemsModal';
import PasswordConfirmModal from 'VueModals/PasswordConfirmModal';
import AddUserModal from 'VueModals/AddUserModal';

export default {
  components: {
    BasicPortlet,
    VjsModal,
    AlertModal,
    ConfirmModal,
    DeleteConfirmModal,
    EntitySelectionModal,
    SocialShareModal,
    SyncItemsToFeedByTagModal,
    SyncFeedTagsToItemsModal,
    PasswordConfirmModal,
    AddUserModal,
  },
  data: () => ({
    feeds: [],
    customer: window.user.customer,
    loading: true,
  }),
  beforeMount() {
    this.modal_types = Object.freeze({
      base: `base`,
      confirm: `confirm`,
      alert: `alert`,
      social: `social`,
      entity_select: `entity_select`,
      delete_confirm: `delete_confirm`,
      sync_feed_item_tags: `sync_feed_item_tags`,
      sync_feed_tags_items: `sync_feed_tags_items`,
      password_confirm: `password_confirm`,
      quick_alert: `quick_alert`,
      add_user: `add_user`,
    });
    this.initData();
  },
  methods: {
    async initData() {
      this.feeds = (await axios.get(`/api/v1/feeds?with_player_data=true`)).data.data;
      this.loading = false;
    },
    async showModal(modal_type, qa_options) {
      if (modal_type === this.modal_types.base) { // template modals are manual
        this.$modal.show(modal_type);
      } else {
        const result = await (modal_type === this.modal_types.quick_alert ?
          this.quickAlert(qa_options) : this.fireModal(modal_type));

        console.group(`result for '${modal_type}':`);
        // eslint-disable-next-line no-console
        console.log(result);
        console.groupEnd();
      }
    },
    hideModal(modal_type) {
      if (modal_type) {
        this.$modal.hide(modal_type);
      } else {
        this.$modal.hideAll();
      }
    },
    exampleBtnClick(msg) {
      // eslint-disable-next-line
      console.log(msg ?? `Example button clicked`);
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-block {
  padding: 0.5em;
  ul {
    li {
      margin-bottom: 0.5em;
    }
  }
}
</style>
